import { Tooltip } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

const BootstrapTooltipStyled = styled(Tooltip)(({ theme }) => ({
  "& .MuiTooltip-arrow": {
    color: "#000",
  },
  "& .MuiTooltip-tooltip": {
    boxShadow: theme.shadows[1],
    color: "#000",
    backgroundColor: "#FFF",
  },
}));

const BigSizeTooltipStyled = styled(Tooltip)(({ theme }) => ({
  "& .MuiTooltip-arrow": {
    color: "#000",
  },
  "& .MuiTooltip-tooltip": {
    boxShadow: theme.shadows[1],
    fontSize: 12,
    padding: "2%",
    color: "#000",
    backgroundColor: "#FFF",
    textAlign: "center",
    minWidth: "800px",
  },
}));

export default function BootstrapTooltip(props) {
  const { bigSize, ...otherProps } = props;

  if (bigSize) {
    return <BigSizeTooltipStyled {...otherProps} />;
  }

  return <BootstrapTooltipStyled {...otherProps} />;
}
